var _title, _desc, _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgNavPlans = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "24px",
    viewBox: "0 0 21 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Plans")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Plans")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.6930719,-1.71773706e-12 C13.8080719,-1.71773706e-12 16.8330719,0.631 19.6820719,1.875 C20.4910719,2.245 21.0060719,3.05 21.0001238,3.929 L21.0001238,11.538 C21.0001238,16.737 17.7400719,21.484 12.8870719,23.351 L11.8460719,23.751 C11.4140719,23.917 10.9610719,24.001 10.5000719,24.001 C10.0390719,24.001 9.58607193,23.917 9.15407193,23.751 L8.11307193,23.351 C3.26007193,21.484 3.57025103e-05,16.737 3.57025103e-05,11.538 L3.57025103e-05,3.924 C-0.00492807434,3.048 0.508071926,2.245 1.30607193,1.88 C4.16607193,0.631 7.18607193,-1.71773706e-12 10.2880719,-1.71773706e-12 L10.6930719,-1.71773706e-12 Z M10.6940719,1.5 L10.5070719,1.501 L10.3000719,1.5 C7.39707193,1.5 4.57707193,2.089 1.91807193,3.249 C1.66507193,3.365 1.49807193,3.629 1.50005416,3.919 L1.50005416,11.538 C1.50005416,16.121 4.37407193,20.306 8.65107193,21.951 L9.69207193,22.351 C9.95207193,22.451 10.2230719,22.502 10.5000719,22.502 C10.7770719,22.502 11.0480719,22.451 11.3080719,22.352 L12.3490719,21.952 C16.6260719,20.305 19.5000895,16.121 19.5000895,11.538 L19.5000895,3.924 C19.5020719,3.631 19.3330719,3.365 19.0700719,3.244 C16.4210719,2.087 13.6010719,1.5 10.6940719,1.5 Z M14,13.5 C14.5522847,13.5 15,13.8357864 15,14.25 C15,14.6642136 14.5522847,15 14,15 L14,15 L7,15 C6.44771525,15 6,14.6642136 6,14.25 C6,13.8357864 6.44771525,13.5 7,13.5 L7,13.5 Z M7,9.5 L14,9.5 C14.5522847,9.5 15,9.83578644 15,10.25 C15,10.632351 14.6185148,10.9478765 14.1254379,10.9941564 L14,11 L7,11 C6.44771525,11 6,10.6642136 6,10.25 C6,9.86764902 6.38148518,9.55212352 6.87456212,9.50584356 L7,9.5 L14,9.5 Z M14,5.5 C14.5522847,5.5 15,5.83578644 15,6.25 C15,6.63235098 14.6185148,6.94787648 14.1254379,6.99415644 L14,7 L7,7 C6.44771525,7 6,6.66421356 6,6.25 C6,5.86764902 6.38148518,5.55212352 6.87456212,5.50584356 L7,5.5 L14,5.5 Z",
    id: "path-nav-plans"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01.-Main-Nav-Icons",
    transform: "translate(-326.000000, -833.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav-Icons",
    transform: "translate(326.000000, 320.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/Plans",
    transform: "translate(0.000000, 513.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-flag-question@24x24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c/grey/600"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "nav-plans-mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-nav-plans"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fillRule: "nonzero",
    xlinkHref: "#path-nav-plans"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#nav-plans-mask-2)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNavPlans, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/nav-plans.a68a55a7.svg";
export { ForwardRef as ReactComponent };